import { useState } from "react";
import "./Language.scss";
import i18next from "i18next";
import EN from "../../../assets/images/flags/en.svg";
import FR from "../../../assets/images/flags/fr.svg";
import AR from "../../../assets/images/flags/ar.svg";
import DE from "../../../assets/images/flags/de.svg";
import ES from "../../../assets/images/flags/es.svg";
import HI from "../../../assets/images/flags/hi.svg";
import ID from "../../../assets/images/flags/id.svg";
import BZ from "../../../assets/images/flags/bz.svg";
import KO from "../../../assets/images/flags/ko.svg";
import PL from "../../../assets/images/flags/pl.svg";
import RU from "../../../assets/images/flags/ru.svg";
import TH from "../../../assets/images/flags/th.svg";
import TR from "../../../assets/images/flags/tr.svg";
import ZHCN from "../../../assets/images/flags/zh-CN.svg";
import { ReactComponent as ICON } from '../../../assets/images/checkbox.svg';
import { ReactComponent as Arrow } from '../../../assets/images/input_arrow_up.svg';
import classNames from "classnames";
import { equalsIgnoreCase } from "../../../_utils";

const language = [
  {
    code: "ar",
    name: "العربية",
    country_code: AR,
  },
  {
    code: "de",
    name: "Deutch",
    country_code: DE,
  },
  {
    code: "en",
    name: "English",
    country_code: EN,
  },
  {
    code: "es",
    name: "Español",
    country_code: ES,
  },
  {
    code: "fr",
    name: "Français",
    country_code: FR,
  },
  {
    code: "hi",
    name: "हिन्दी",
    country_code: HI,
  },
  {
    code: "id",
    name: "Indonesian",
    country_code: ID,
  },
  {
    code: "ko",
    name: "한국어",
    country_code: KO,
  },
  {
    code: "pt",
    name: "Brazil Português",
    country_code: BZ,
  },
  {
    code: "pl",
    name: "Polski",
    country_code: PL
  },
  {
    code: "ru",
    name: "Русский",
    country_code: RU,
  },
  {
    code: "th",
    name: "ภาษาไทย",
    country_code: TH,
  },
  {
    code: "tr",
    name: "Türkçe",
    country_code: TR
  },
  {
    code: "zh",
    name: "中文 (简体)",
    country_code: ZHCN
  }
];

const Language = () => {
  const [isList, setIsList] = useState(false);
  const currentLanguageCode = i18next.language || "en";
  const currenLang = language.find((l) => l.code === currentLanguageCode);

  return (
    <div className="translate_wrapper" onClick={() => setIsList(!isList)}>
      <button className={`current_lang ${isList && "active_lang"}`}>
        <img src={currenLang.country_code} alt="icon" />
        {currenLang.code}
        <Arrow />
      </button>
      {isList && <div onClick={() => setIsList(false)}>
        <div className="more_lang" onClick={e => e.stopPropagation()}>
          {language.map(({ code, name, country_code }) => (
            <button
              onClick={() => {
                i18next.changeLanguage(code);
                setIsList(false);
              }}
              className={classNames("lang", `lang${code.toUpperCase()}`, {
                active: code === currentLanguageCode
              })}
              key={country_code}
              data-test={code.toUpperCase()}
            >
              <img src={country_code} alt="icon" />
              <span className="lang-txt">{name}</span>
              {(equalsIgnoreCase(currenLang.country_code, country_code)) && <ICON />}
            </button>
          ))}
        </div>
      </div>}
    </div>
  );
};

export default Language;
